import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { CdkMenu, CdkMenuModule } from '@angular/cdk/menu';

import {MatChipsModule} from '@angular/material/chips';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
// import { SchemaTree } from '../../interfaces/SchemaTree_old';
import { SchemaTreeResult } from '../../interfaces/SchemaTreeResult';
import { convertIntoTreeMenuActionEnum } from '../../utils/utils';
import { SchemaTree } from '../../clases/SchemaTree';
import { ERROR, TAXONOMY_TREE_CONTEXT_MENU_OPTIONS } from '../../shared/strings';
import { NotifyDialogService } from '../../services/notify-dialog.service';

@Component({
  selector: 'context-menu',
  standalone: true,
  imports: [MatChipsModule, MatButtonModule, MatIconModule, CdkMenuModule],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss'
})
export class ContextMenuComponent implements OnInit {

  CONTEXT_OPTIONS = TAXONOMY_TREE_CONTEXT_MENU_OPTIONS;

  @Input() schemaTree!: SchemaTree;
  @Output() result: EventEmitter<SchemaTreeResult> = new EventEmitter();

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('options', { static: false }) menu!: CdkMenu;

  constructor(public notifyDialogService: NotifyDialogService){}

  ngOnInit(): void {}

  selectNode(action: string){
    this.result.emit({ schema: this.schemaTree, type: convertIntoTreeMenuActionEnum(action)});
    this.onClose();
  }

  onSelectFile() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event, action: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
  
    if (file) {
      const reader = new FileReader();
  
      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result as string);
          json[0].config.schemas_father_UUID = this.schemaTree.UUID;
          this.result.emit({ schema: this.schemaTree, type: convertIntoTreeMenuActionEnum(action), imported: json});
          this.onClose();
        } catch (error) {
          this.notifyDialogService.openDialog(ERROR, this.CONTEXT_OPTIONS.invalid_json_file + error);
        }
      };
  
      reader.onerror = () => {
        this.notifyDialogService.openDialog(ERROR, this.CONTEXT_OPTIONS.file_reading_error + reader.error);
      };
  
      reader.readAsText(file);
    }
  }

  checkSchema(){
    return this.schemaTree.label.includes("Schema");
  }

  checkSubclass(){
    return this.schemaTree.label.includes("SUBCLASS");
  }

  onClose(){
    this.menu.menuStack.closeAll();
  }
}
